module.exports = __webpack_public_path__ + "img/purchase_banner4.7966ffb2.png";